'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoSkipForward = function IoSkipForward(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm34.1 7.5c0.5 0 0.9 0.4 0.9 0.9v23.2c0 0.5-0.4 0.9-0.9 0.9h-0.7c-0.5 0-0.9-0.4-0.9-0.9v-8.9l-14.6 9.6c-0.2 0.1-0.4 0.2-0.6 0.2-0.7 0-1.2-0.5-1.2-1.3v-5l-9.3 6.1c-0.2 0.1-0.4 0.2-0.6 0.2-0.7 0-1.2-0.5-1.2-1.3v-22.4c0-0.8 0.5-1.3 1.2-1.3 0.2 0 0.4 0 0.6 0.2l9.3 6.1v-5c0-0.8 0.5-1.3 1.2-1.3 0.2 0 0.4 0.1 0.6 0.2l14.6 9.6v-8.9c0-0.5 0.4-0.9 0.9-0.9h0.7z' })
        )
    );
};

exports.default = IoSkipForward;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/skip-forward.js
// module id = 2647
// module chunks = 0